import { Link } from "react-router-dom";
import { clsx } from "clsx";
import { FeedLinkProps } from "@/common/utils/feedResume";
import "./TabLink.scss";

interface ITabLinkProps {
  title: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  isActive?: boolean;
  link?: string;
  linkComponentProps?: FeedLinkProps;
  onClick?: () => void;
}

export const TabLink = ({ title, icon: Icon, isActive, link, linkComponentProps, onClick }: ITabLinkProps) => {
  const className = clsx(
    "TabLink",
    `TabLink_${`is${title}`}`,
    isActive && "TabLink_isActive",
  );
  const handleClick = onClick ?? (() => {});

  if (link !== undefined) {
    return (
      <Link
        to={link}
        {...linkComponentProps}
        onClick={handleClick}
        className={className}
        aria-label={title}
      >
        <div className="TabLink-Icon"><Icon /></div>
        <span>{title}</span>
      </Link>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={className}
      aria-label={title}
    >
      <div className="TabLink-Icon"><Icon /></div>
      <span>{title}</span>
    </button>
  );
};
